import useLogout from '../../context/user/hooks/useLogout';
import Header from '../Header';
import { Wrapper } from './styles';
import logo from '../../resources/logo.png';
import CatalogSlideContainerComponent from '../CatalogSlideContainer';
import { IdCatalogSearchProvider } from '../SideMenuSearchLane/context';
import StandardizationScreenProvider from '../../screens/StandardizationScreen/context';
import { CompareManagementProvider } from '../SideMenuSearchLane/context/compare';

const AppLayout = ({ children }) => {
  const { logoutUser } = useLogout();
  return (
    <IdCatalogSearchProvider>
      <StandardizationScreenProvider>
        <Wrapper>
          <Header
            title=''
            logo={logo}
            logoutUser={logoutUser}
          />
          <CompareManagementProvider>
            <CatalogSlideContainerComponent />
          </CompareManagementProvider>
          {children}
        </Wrapper>
      </StandardizationScreenProvider>
    </IdCatalogSearchProvider>
  );
};

export default AppLayout;
